module.exports = __webpack_public_path__ + "static/onion-00ca76f5fc197b4711b959d6a6befadd.svg";